import { render, staticRenderFns } from "./ActivityThanksCompleted.vue?vue&type=template&id=282f3fb8&scoped=true"
import script from "./ActivityThanksCompleted.vue?vue&type=script&lang=js"
export * from "./ActivityThanksCompleted.vue?vue&type=script&lang=js"
import style0 from "./ActivityThanksCompleted.vue?vue&type=style&index=0&id=282f3fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f3fb8",
  null
  
)

export default component.exports